type FroonzeWindow = Window & {
  frcp?: {
    wishlist?: {
      toggleWidget?: () => void;
      data?: {
        guest?: {
          add?: Record<string, unknown>;
        };
      };
    };
  };
};

export function initHeaderWishlist(): void {
  const headerWishlistLink = document.getElementById("header-wishlist-link");

  headerWishlistLink?.addEventListener("click", (event) => {
    event.preventDefault();
    (window as FroonzeWindow).frcp?.wishlist?.toggleWidget?.();
  });

  function updateWishlistCount(): void {
    const countBubble = document.getElementById("wishlist-count-bubble");
    const countSpan = document.getElementById("wishlist-count");
    const wishlistLink = document.getElementById("header-wishlist-link");
    if (!countBubble || !countSpan) return;

    const wishlistData = (window as FroonzeWindow).frcp?.wishlist?.data;
    const count = wishlistData?.guest?.add ? Object.keys(wishlistData.guest.add).length : 0;

    if (count > 0) {
      countSpan.textContent = count < 100 ? String(count) : "99+";
      countBubble.style.display = "flex";
      wishlistLink?.classList.add("has-items");
    } else {
      countBubble.style.display = "none";
      wishlistLink?.classList.remove("has-items");
    }
  }

  setTimeout(updateWishlistCount, 500);

  document.addEventListener("frcp:wishlist:change", updateWishlistCount);
  document.addEventListener("frcp:wishlist:add", updateWishlistCount);
  document.addEventListener("frcp:wishlist:remove", updateWishlistCount);

  document.addEventListener("click", (event) => {
    const target = event.target as Element | null;
    if (!target?.closest(".frcp-wishlist-btn, [data-frcp-wishlist]")) return;

    setTimeout(updateWishlistCount, 100);
    setTimeout(updateWishlistCount, 300);
  });

  setInterval(updateWishlistCount, 10000);
}
